module.exports = __webpack_public_path__ + "img/5-cartoon.93d0268f.jpg";